// extracted by mini-css-extract-plugin
module.exports = {"card":"_3B5De","cardContent":"_33itj","noBorderTop":"_2dBWz","image":"lFUPe"};